export const VERIFICATION_ERROR = 'error.license token not valid'
export const OVER_LIMIT = 'error.count over license limit'
